<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3472 20.0528C16.6013 21.7987 12.1302 20.1582 8.36065 16.3886C4.59111 12.6191 2.95062 8.14794 4.6965 6.40205L5.84604 5.25251C6.63963 4.45892 7.94727 4.4799 8.76673 5.29937L10.5473 7.0799C11.3667 7.89936 11.3877 9.207 10.5941 10.0006L10.3472 10.2475C9.91874 10.676 9.87682 11.3672 10.2749 11.8496C10.659 12.315 11.073 12.7785 11.5219 13.2274C11.9708 13.6763 12.4343 14.0903 12.8996 14.4743C13.3821 14.8725 14.0733 14.8305 14.5018 14.4021L14.7487 14.1552C15.5423 13.3616 16.8499 13.3825 17.6694 14.202L19.4499 15.9825C20.2694 16.802 20.2903 18.1096 19.4968 18.9032L18.3472 20.0528Z"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M17.0648 10.0308C16.8468 9.49909 16.522 9.00094 16.0902 8.5692C15.6829 8.16185 15.2164 7.84965 14.7184 7.63261"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M14.7184 4.59258C15.9107 5.02452 17.0294 5.71842 17.9852 6.6743C18.9651 7.65417 19.6697 8.80511 20.099 10.0311"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>